/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const Gear16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray}
            fillRule="evenodd"
            d="M9.339 1a.82.82 0 01.822.7l.213 1.447c.258.12.506.26.745.422l1.428-.558c.374-.132.81.012 1.004.36l1.342 2.259a.82.82 0 01-.213 1.058l-1.185.902a4.6 4.6 0 010 .82l1.187.903c.326.25.412.7.205 1.068l-1.33 2.238a.831.831 0 01-1.026.364l-1.415-.552c-.243.162-.49.303-.742.421l-.212 1.439a.823.823 0 01-.823.709H6.666a.82.82 0 01-.822-.7l-.214-1.447a5.4 5.4 0 01-.744-.422l-1.428.558c-.375.132-.81-.012-1.004-.36L1.11 10.37a.822.822 0 01.214-1.058l1.184-.902a4.666 4.666 0 010-.82l-1.186-.903a.813.813 0 01-.206-1.068l1.33-2.238a.831.831 0 011.026-.364l1.415.552c.244-.162.49-.303.742-.421l.212-1.439A.823.823 0 016.666 1h2.673zm-.145 1H6.81l-.269 1.825-.486.228c-.203.095-.406.21-.611.348l-.434.29L3.243 4 2.059 5.99l1.495 1.137-.048.55a3.67 3.67 0 000 .645l.048.55-1.494 1.136 1.182 1.99 1.768-.69.435.293a4.4 4.4 0 00.607.344l.489.227.27 1.827h2.383l.27-1.825.486-.228c.203-.095.405-.21.61-.348l.434-.29 1.768.69 1.183-1.99-1.495-1.137.049-.55a3.602 3.602 0 000-.644l-.049-.55 1.495-1.137L12.762 4l-1.768.69-.434-.293a4.4 4.4 0 00-.607-.344l-.49-.227L9.194 2zM8.001 5c1.653 0 3 1.346 3 3s-1.347 3-3 3c-1.654 0-3-1.346-3-3s1.346-3 3-3zm0 1c-1.102 0-2 .899-2 2s.898 2 2 2c1.101 0 2-.899 2-2s-.899-2-2-2z"
        />
    </AccessibleSVG>
);

export default Gear16;
